import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageToggle() {
  const { lang, setLang } = useLanguage();

  return (
    <div style={{
      display: 'flex',
      borderRadius: 20,
      overflow: 'hidden',
      border: '1px solid rgba(11,180,170,0.5)',
      fontSize: 12,
      fontWeight: 600,
    }}>
      <button
        onClick={() => setLang('th')}
        style={{
          padding: '5px 10px',
          background: lang === 'th' ? '#0bb4aa' : 'transparent',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          transition: 'background 0.2s',
        }}
      >
        TH
      </button>
      <button
        onClick={() => setLang('en')}
        style={{
          padding: '5px 10px',
          background: lang === 'en' ? '#0bb4aa' : 'transparent',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          transition: 'background 0.2s',
        }}
      >
        EN
      </button>
    </div>
  );
}
